import { PropsWithChildren, ReactNode } from 'react';

type ConditionalRenderProps = PropsWithChildren<{
  show?: boolean;
  placeholder?: ReactNode;
}>;

export const ConditionalRender = ({ show, placeholder = null, children }: ConditionalRenderProps) => {
  if (show) return children;
  return placeholder;
};
